module.exports = __webpack_public_path__ + "img/x-circle.f0c03dd2.svg";